import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import {
  KibSuperSelect,
  type KibSuperSelectOption,
} from '@chewy/kib-fields-new-react'
import * as R from 'ramda'
import type { Field } from '@pbt/pbt-ui-components'

import { getTimelineIsLoading } from '~/store/reducers/timeline'

import '@chewy/kib-fields-new-styles/dist/kib-fields-new.css'
import '@chewy/kib-interstitials-styles/dist/styles/kib-spinner.css'
import styles from './AppointmentSelect.module.scss'

const AppointmentSelect = ({
  appointments,
  appointmentField,
  patientName,
}: {
  appointmentField: Field
  appointments: KibSuperSelectOption[]
  patientName: string
}) => {
  const { t } = useTranslation(['Dialogs'])
  const isLoadingAppointments = useSelector(getTimelineIsLoading)

  const noAppointments = R.isEmpty(appointments)

  const loadingPlaceholder = t(
    'Dialogs:NEW_CONVERSATION_WITH_STEPS_DIALOG.LINK_TO_APPOINTMENT_PLACEHOLDER',
  )

  const loadedPlaceholder = noAppointments
    ? t(
        'Dialogs:NEW_CONVERSATION_WITH_STEPS_DIALOG.PATIENT_HAS_NO_APPOINTMENTS',
        { patientName },
      )
    : t(
        'Dialogs:NEW_CONVERSATION_WITH_STEPS_DIALOG.LINK_TO_APPOINTMENT_PLACEHOLDER',
      )

  const placeholder = isLoadingAppointments
    ? loadingPlaceholder
    : loadedPlaceholder

  return (
    <KibSuperSelect
      className={styles.appointmentSelector}
      disabled={isLoadingAppointments || noAppointments}
      label={t(
        'Dialogs:NEW_CONVERSATION_WITH_STEPS_DIALOG.LINK_TO_APPOINTMENT',
      )}
      loading={isLoadingAppointments}
      options={appointments}
      placeholder={placeholder}
      value={appointmentField.value}
      onChange={(selected) => {
        appointmentField.setValue(selected)
      }}
    />
  )
}

export default AppointmentSelect
